// extracted by mini-css-extract-plugin
export default {"root":"AdvancedSetting_root__VGvAh","tips":"AdvancedSetting_tips__olALZ","inputNumber":"AdvancedSetting_inputNumber__3eHXC","wrapper":"AdvancedSetting_wrapper__h7QAN"};